module.exports = __webpack_public_path__ + "img/proyecto.1ba6eeea.png";